
import {TRACKER_TYPES} from 'consts/ttypes'

export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    company_type(){
      return this.type == undefined ? {title: 'Not Tracked', icon: undefined} : TRACKER_TYPES.find(x => x.value === this.type)
    },
  }
}
